import axios from 'axios';
import config from '../common/config';

export default {
  // Takes the storage URL of an already-uploaded document, not the file. The
  // bytes used to be posted here and then handed to the worker as a Redis job
  // argument, which put 7-10MB into a 25MB instance per import and filled it.
  parseDocument(token, { url, mimeType, language }) {
    return axios.post(
      `${config.config.ROOT_URL}/parse_document_api`,
      { url, mime_type: mimeType, language },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },

  getJobStatus(token, jobId) {
    return axios.get(`${config.config.ROOT_URL}/job_status/${jobId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  parseText(token, text, language) {
    return axios.post(
      `${config.config.ROOT_URL}/parse_text_api`,
      { text, language },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },

  generateRideFromAttractions(token, { startDate, endDate, travelersInfo, language,
    destinationLat, destinationLng, destinationName, exampleRideIds }) {
    return axios.post(
      `${config.config.ROOT_URL}/generate_ride_from_attractions_api`,
      {
        start_date: startDate,
        end_date: endDate,
        travelers_info: travelersInfo,
        language,
        destination_lat: destinationLat,
        destination_lng: destinationLng,
        destination_name: destinationName,
        example_ride_ids: exampleRideIds,
      },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },

  suggestRideName(token, documents, language) {
    return axios.post(
      `${config.config.ROOT_URL}/suggest_ride_name_api`,
      { documents, language },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },

};
